import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import { PREVIEW_TIERS, previewPath } from "@/lib/plans";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const home = user ? (user.role === "admin" ? "/admin" : user.role === "provider" ? "/provider" : "/dashboard") : "/";

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/70 border-b border-black/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to={home} data-testid="nav-logo" className="flex items-center">
          <img src="/plantflow-logo.png" alt="PlantFlow" className="h-11 w-auto object-contain rounded-lg" />
        </Link>
        <nav className="flex items-center gap-2 sm:gap-4">
          {!user && (
            <>
              <Link to="/blog" data-testid="nav-blog" className="text-sm text-stone-600 hover:text-emerald-900 transition-colors px-3">Blog</Link>
              <Link to="/pricing" data-testid="nav-pricing" className="text-sm text-stone-600 hover:text-emerald-900 transition-colors px-3">Pricing</Link>
              <Button data-testid="nav-signin" onClick={() => navigate("/auth")} className="rounded-full bg-emerald-900 hover:bg-emerald-800 text-white">Sign in</Button>
            </>
          )}
          {user && (
            <>
              {user.role === "admin" && (
                <>
                  <Link to="/admin" data-testid="nav-admin" className="text-sm text-emerald-800 font-medium hover:text-emerald-900 transition-colors px-3">Admin</Link>
                  <Link to="/provider" data-testid="nav-jobboard" className="text-sm text-stone-600 hover:text-emerald-900 transition-colors px-3">Job Board</Link>
                  <select
                    data-testid="preview-as-role"
                    defaultValue=""
                    onChange={(e) => {
                      const tier = e.target.value;
                      e.target.value = "";
                      if (!tier) return;
                      window.open(`${previewPath(tier)}?preview=${tier}`, "_blank", "noopener");
                    }}
                    className="text-xs rounded-full border border-emerald-200 bg-emerald-50 text-emerald-800 px-3 py-1.5 cursor-pointer hover:bg-emerald-100 transition-colors focus:outline-none"
                    title="Open a read-only subscriber preview in a new tab"
                  >
                    <option value="" disabled>Preview as Role</option>
                    {PREVIEW_TIERS.map((t) => (
                      <option key={t.key} value={t.key}>{t.label}</option>
                    ))}
                  </select>
                </>
              )}
              <Link to="/grass" data-testid="nav-grass" className="text-sm text-stone-600 hover:text-emerald-900 transition-colors px-3">Turf ID</Link>
              <Link to="/blog" data-testid="nav-blog" className="text-sm text-stone-600 hover:text-emerald-900 transition-colors px-3">Blog</Link>
              <Link to="/settings" data-testid="nav-settings" className="text-sm text-stone-600 hover:text-emerald-900 transition-colors px-3">Settings</Link>
              <span className="hidden sm:inline text-xs uppercase tracking-[0.2em] text-stone-500">{user.plan} · {user.role}</span>
              <span className="text-sm font-medium text-emerald-950">{user.name}</span>
              <Button data-testid="nav-logout" variant="ghost" size="sm" onClick={() => { logout(); navigate("/"); }} className="rounded-full text-stone-600 hover:text-emerald-900">
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};
